// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"DVjqeRU","shine":"_34NOjcM"};